import React from 'react';
import styled from 'styled-components';
import { formatDateTime } from '../../utils';

type MessageBubbleProps = {
  name: string;
  type: string;
  messageBody: string;
  date: Date;
};

const Container = styled.div<{ type: string }>`
  display: flex;
  flex-direction: column;
  ${props => (props.type === 'OUTGOING' ? 'align-items: flex-end;' : '')}
`;

const Label = styled.div`
  font-size: 12px;
  color: #9ea2ac;
  margin: 4px 0;
`;

const Body = styled.div<{ type: string }>`
  font-size: 14px;
  padding: 10px 8px;
  border-radius: 10px;
  margin-top: 2px;
  width: fit-content;
  word-wrap: break-word;
  max-width: 85%;
  ${props =>
    props.type === 'INCOMING'
      ? `
    background-color: #F3F4F6;
    border-bottom-left-radius: 0px;
  `
      : props.type === 'OUTGOING'
      ? `
    color: white;
    background-color: #5046E5;
    border-bottom-right-radius: 0px;
  `
      : ''}
`;

const MessageBubble = ({ name, type, messageBody, date }: MessageBubbleProps) => {
  return (
    <Container type={type}>
      <Label>{name}</Label>
      <Body type={type}>{messageBody}</Body>
      <Label>{formatDateTime(date)}</Label>
    </Container>
  );
};

export default MessageBubble;
